import type { WordCollection } from "../collection.types";
import { createCollection } from "../logic";

// Removed deduplicateArray and local createCollection helper

const colorsWordList = [
  "absorb",
  "beam",
  "black",
  "blue",
  "brass",
  "bright",
  "bronze",
  "burn",
  "cream",
  "dark",
  "dim",
  "flash",
  "glow",
  "gold",
  "green",
  "mint",
  "olive",
  "orange",
  "purple",
  "ray",
  "red",
  "shade",
  "shadow",
  "silver",
  "spectrum",
  "transparent",
  "vibrant",
  "yellow",
]; // Removed deduplicateArray wrapper

export const colorsCollection: WordCollection = createCollection(
  "colors",
  "Colors & Light",
  colorsWordList,
  { icon: "palette", isWordlistViewable: true },
);
